import axios from "axios";
import authHeader from './auth.header'
import Swal from "sweetalert2";

const API_URL = "https://identity-visitantes.aceitesa.com/";
const LOCAL_URL = 'http://localhost:5200/'

const register = async ({...data}) => {
  var config = {
    headers: authHeader(),
    'Content-type': 'application/json',
  }
  try{
    const response = await axios.post(`${API_URL}sing-up`, 
    {...data}, config
    );
    Swal.fire({
      icon: "success",
      title: "Usuario creado",
      text: `El usuario ha sido creado con exito`,
      confirmButtonText: "Ok",
      confirmButtonColor: "#3085d6",
    });
    return response.data;
  }catch(error){
    if(error.response.status === 400){
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: `${error.response.data.message}`,
        confirmButtonText: "Ok",
        confirmButtonColor: "#3085d6",
      });
    }else{
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: `${error.response.data.message}`,
        confirmButtonText: "Ok",
        confirmButtonColor: "#3085d6",
      });
    }
    return error
  }
};

const loginWithToken = async(email, appkey) => {
  var config = {
    headers: authHeader(),
    'Content-type': 'application/json',
  }
  try{
    const response = await axios.post(`${API_URL}sing-in-by-token`, {
      email,
      appkey,
    }, config)
    if (response.data.accessToken) {
      localStorage.setItem("user", JSON.stringify(response.data));
    }
    return response.data;
  }catch(error){
    Swal.fire({
      icon: "error",
      title: "Oops...",
      text: "No se puede iniciar sesión",
      confirmButtonText: "Ok",
      confirmButtonColor: "#3085d6",
    });
  }
}

const login = async (email, password) => {
  var config = {
    headers: authHeader(),
    'Content-type': 'application/json',
  }
  try{
    const response = await axios.post(`${API_URL}sing-in`, {
      email,
      password,
    }, config)
    if (response.data.accessToken) {
      localStorage.setItem("user", JSON.stringify(response.data));
    }
    return response.data;
  }catch(error){
    Swal.fire({
      icon: "error",
      title: "Oops...",
      text: `${error.response.data.message}`,
      confirmButtonText: "Ok",
      confirmButtonColor: "#3085d6",
    });
  }
};

const recoveryPassword = async (email) => {
  var config = {
    headers: authHeader(),
    'Content-type': 'application/json',
  }
  try{
    const response = await axios.post(`${API_URL}forgot-password`, 
    {"email": email},
    config)
    return response.data;
  }catch(error){
    Swal.fire({
      icon: "error",
      title: "Oops...",
      text: `${error.response.data.message}`,
      confirmButtonText: "Ok",
      confirmButtonColor: "#3085d6",
    });
  }
};

const resetPassword = async (form) => {
  var config = {
    headers: authHeader(),
    'Content-type': 'application/json',
  }
  try{
    const response = await axios.post(`${API_URL}reset-password`, 
      form,
     config)
    return response.data;
  }catch(error){
    Swal.fire({
      icon: "error",
      title: "Oops...",
      text: `${error.response.data.message}`,
      confirmButtonText: "Ok",
      confirmButtonColor: "#3085d6",
    });
  }
};

const registerUserApprover = ({...data}) => {
  var config = {
    headers: authHeader(),
    'Content-type': 'application/json',
  }
  return axios
    .post(`${API_URL}register-user-approver`, {
      ...data
    }, config)
}

const getUserRole =  async () => {
  var config = {
    headers: authHeader(),
    'Content-type': 'application/json',
  }
    const response = await axios.get(`${API_URL}get-user-role`,
    config)

    return response.data
  }


const logout = () => {
  localStorage.removeItem("user");
};

export const getUserApprover = async () => {
  var config = {
    headers: authHeader(),
    'Content-type': 'application/json',
  }
  const response = await axios.get(`${API_URL}get-users-approver`, config)
  return response.data
}

export default {
  register,
  login,
  loginWithToken,
  registerUserApprover,
  logout,
  getUserRole,
  recoveryPassword,
  resetPassword
};